// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditableTextField_label__L2S5A {
  font-size: var(--mantine-font-size-sm);
  font-weight: 500;
  color: var(--mantine-color-gray-9);
  margin-bottom: 0.375rem;
}

.EditableTextField_editorContainer__ywi0K {
  border: 1px solid var(--mantine-color-gray-4);
  border-radius: var(--mantine-radius-xmd);
}

.EditableTextField_hiddenEditor__0KZwA {
  color: transparent;
  caret-color: black;
  background-color: transparent;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.EditableTextField_variable__4WZDx {
  background: linear-gradient(to right, transparent 1px, var(--mantine-color-purple-0) 0 calc(100% - 1px), transparent 0);
  border-radius: 4px;
  color: var(--primary-color);
  cursor: help;
  white-space: nowrap;
  z-index: 1;
  position: relative;
}
.EditableTextField_variable__4WZDx:hover {
  background: linear-gradient(to right, transparent 1px, #ebedf4 0 calc(100% - 1px), transparent 0);
}

.EditableTextField_variableKey__R3OeN {
  position: absolute;
  left: 0;
  color: transparent;
}

.EditableTextField_tooltipWrapper__DWJ6I {
  display: inline-block;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/components/EditableTextField/index.module.scss"],"names":[],"mappings":"AAAA;EACE,sCAAA;EACA,gBAAA;EACA,kCAAA;EACA,uBAAA;AACF;;AAEA;EACE,6CAAA;EACA,wCAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,uHAAA;EAMA,kBAAA;EACA,2BAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AAJF;AAME;EACE,iGAAA;AAJJ;;AAaA;EACE,kBAAA;EACA,OAAA;EACA,kBAAA;AAVF;;AAaA;EACE,qBAAA;EACA,kBAAA;AAVF","sourcesContent":[".label {\n  font-size: var(--mantine-font-size-sm);\n  font-weight: 500;\n  color: var(--mantine-color-gray-9);\n  margin-bottom: 0.375rem;\n}\n\n.editorContainer {\n  border: 1px solid var(--mantine-color-gray-4);\n  border-radius: var(--mantine-radius-xmd);\n}\n\n.hiddenEditor {\n  color: transparent;\n  caret-color: black;\n  background-color: transparent;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.variable {\n  background: linear-gradient(\n    to right,\n    transparent 1px,\n    var(--mantine-color-purple-0) 0 calc(100% - 1px),\n    transparent 0\n  );\n  border-radius: 4px;\n  color: var(--primary-color);\n  cursor: help;\n  white-space: nowrap;\n  z-index: 1;\n  position: relative;\n\n  &:hover {\n    background: linear-gradient(\n      to right,\n      transparent 1px,\n      #ebedf4 0 calc(100% - 1px),\n      transparent 0\n    );\n  }\n}\n\n.variableKey {\n  position: absolute;\n  left: 0;\n  color: transparent;\n}\n\n.tooltipWrapper {\n  display: inline-block;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `EditableTextField_label__L2S5A`,
	"editorContainer": `EditableTextField_editorContainer__ywi0K`,
	"hiddenEditor": `EditableTextField_hiddenEditor__0KZwA`,
	"variable": `EditableTextField_variable__4WZDx`,
	"variableKey": `EditableTextField_variableKey__R3OeN`,
	"tooltipWrapper": `EditableTextField_tooltipWrapper__DWJ6I`
};
export default ___CSS_LOADER_EXPORT___;
